// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, DatePicker, Select, Button } from "antd";
import { Pagination } from "antd";
import { Row, Col, PageHeader } from "antd";
import _ from "lodash/array";

import PropTypes from "prop-types";
import accounting from "accounting";

import moment from "moment";
import "moment/locale/ru";

import Can from "../../../rules/Can";

const { RangePicker } = DatePicker;
const Option = Select.Option;

class DataList extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  render() {
    const {
      loading,
      report,
      meta,
      totals,
      fetchParams,
      period,
      onChangeDateRange,
      onChangePeriod,
      onChangePage,
      onChangeLimit,
      downloadReport,
      currentUser
    } = this.props;

    const dateFormat = "DD.MM.YYYY";

    let reportData = report;
    if (reportData.length > 0) {
      reportData.unshift({
        id: Date.now(),
        product_id: null,
        product_name: null,
        description: null,
        date: null,
        company_name: null,
        assignee: null,
        amount: totals.total,
        vat: totals.vat,
        order_id: null,
        order_number: null,
        purchase_id: null,
        purchase_code: null,
        isGoup: true
      });
    }

    const columns = [
      {
        title: "Дата",
        dataIndex: "date",
        render: (date, record) => {
          if (record.isGoup) {
            return {
              children: <b>Итого</b>,
              props: {
                colSpan: 3,
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: moment(date).format("L")
          };
        },
        align: "left",
        width: "10%"
      },
      {
        title: "Заказ",
        dataIndex: "order_number",
        render: (order_number, record) => {
          if (record.isGoup) {
            return {
              props: {
                colSpan: 0,
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: (
              <Link to={`/orders/${record.order_id}/edit`}>{order_number}</Link>
            )
          };
        },
        align: "center",
        width: "10%"
      },
      {
        title: "Договор субподряда",
        dataIndex: "purchase_code",
        render: (purchase_code, record) => {
          if (record.isGoup) {
            return {
              props: {
                colSpan: 0,
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: (
              <Link to={`/purchases/${record.purchase_id}/edit`}>{purchase_code}</Link>
            )
          };
        },
        align: "center",
        width: "10%"
      },
      {
        title: "Сумма",
        dataIndex: "amount",
        render: (amount, record) => {
          if (record.isGoup) {
            return {
              children: (
                <b>{accounting.formatNumber(Number(record.amount), 0, " ")}</b>
              ),
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: accounting.formatNumber(Number(record.amount), 0, " ")
          };
        },
        align: "right",
        width: "15%"
      },
      {
        title: "Сумма НДС",
        dataIndex: "vat",
        render: (vat, record) => {
          if (record.isGoup) {
            return {
              children: <b>{accounting.formatNumber(Number(vat), 0, " ")}</b>,
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: accounting.formatNumber(Number(vat), 0, " ")
          };
        },
        align: "right",
        width: "15%"
      },

      {
        title: "Компания",
        dataIndex: "company_name",
        render: (company_name, record) => {
          if (record.isGoup) {
            return {
              props: {
                className: "ant-table-total-column"
              }
            };
          }
          return {
            children: record.company_name
          };
        },

        key: "company_name",
        width: "35%"
      }
    ];

    let excelButton = (
      <Button
        key="3"
        type="dashed"
        icon="file-excel"
        onClick={downloadReport}
      >
        Загрузить
      </Button>
    );

    return (
      <PageHeader
        onBack={() => window.history.back()}
        title={`Списания ДС за период c ${fetchParams.startDate} по ${fetchParams.endDate
          }`}
        extra={[
          <Can
            role={currentUser.role}
            perform="reports:download"
            yes={() => (
              excelButton
            )}
            no={() =>
              null
            }
          />
        ]}
        footer={
          <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
            <Col span={24}>
              <Table
                bordered
                size={"middle"}
                loading={loading}
                pagination={false}
                columns={columns}
                dataSource={reportData}
                rowKey="id"
              />
            </Col>
            <Col
              span={24}
              style={{ paddingTop: "15px", paddingBottom: "15px" }}
            >
              <Pagination
                showSizeChanger
                pageSizeOptions={["30", "60", "100", "200"]}
                pageSize={fetchParams.limit}
                current={meta.current_page}
                onChange={onChangePage}
                onShowSizeChange={onChangeLimit}
                total={meta.total_count}
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <RangePicker
              style={{ width: "100%" }}
              value={[
                moment(fetchParams.startDate, dateFormat),
                moment(fetchParams.endDate, dateFormat)
              ]}
              format={dateFormat}
              onChange={onChangeDateRange}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6}>
            <Select
              style={{ width: "100%" }}
              value={period}
              placeholder="Период"
              optionFilterProp="children"
              filterOption={false}
              onChange={onChangePeriod}
            >
              <Option value={0}>произвольный период</Option>
              <Option value={1}>этот месяц</Option>
              <Option value={2}>этот квартал</Option>
              <Option value={3}>этот год</Option>
              <Option value={4}>прошлый месяц</Option>
              <Option value={5}>прошлый квартал</Option>
              <Option value={6}>прошлый год</Option>
            </Select>
          </Col>
        </Row>
      </PageHeader>
    );
  }
}

DataList.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.object,
  fetchParams: PropTypes.object
};

export default DataList;
